import React from "react";

function Dass() {
  return (
    <div className="w-full mx-auto space-y-5">
      {/* Brand Intro */}
      <div className="bg-gray-50 p-6 rounded-xl shadow-sm">
        <h1 className="text-3xl font-bold text-gray-900">Dass</h1>
        <p className="text-gray-700 leading-relaxed text-base">
          <strong>Dass</strong> is a pioneering brand established in 1957,
          specializing in the production of bicycle parts for both the Indian
          and global markets. The brand has built a reputation as a leader in
          bicycle brakes and various other components.
        </p>
      </div>

      {/* Key Products */}
      <div className="max-sm:px-4">
        <h2 className="text-xl font-semibold text-gray-900">
          Key Products
        </h2>
        <ul className="list-disc pl-6 text-gray-700 text-sm space-y-1">
          <li>Disc Brakes</li>
          <li>Caliper Brakes</li>
          <li>Cantilever Brakes</li>
          <li>V-Brakes</li>
          <li>Brake Levers</li>
          <li>Hubs</li>
          <li>Air Pumps</li>
        </ul>
      </div>

      {/* Manufacturing Capabilities */}
      <div className="max-sm:px-4">
        <h2 className="text-xl font-semibold text-gray-900">
          Manufacturing Capabilities
        </h2>
        <ul className="list-none space-y-3 text-gray-700 text-sm">
          <li>
            <strong className="text-gray-900">Advanced Machinery:</strong>{" "}
            Utilizes imported and domestically made machinery including cold
            forging, CNC turning, sheet cutting, plating (zinc & chrome),
            phosphating, heat treatment, paint shop, and testing lab.
          </li>
          <li>
            <strong className="text-gray-900">Tool Room:</strong> Equipped with
            modern die-making machines.
          </li>
          <li>
            <strong className="text-gray-900">
              Environmental Responsibility:
            </strong>{" "}
            Operates an effluent treatment plant to ensure sustainable
            production practices.
          </li>
        </ul>
      </div>

      {/* Certifications & Recognition */}
      <div className="max-sm:px-4">
        <h2 className="text-xl font-semibold text-gray-900">
          Certifications & Recognition
        </h2>
        <ul className="list-disc pl-6 text-gray-700 text-sm space-y-2">
          <li>
            <strong className="text-gray-900">Quality Standards:</strong>{" "}
            Achieved QS-9000 certification, highlighting commitment to high
            manufacturing standards.
          </li>
          <li>
            <strong className="text-gray-900">Supplier to OEMs:</strong>{" "}
            Supplies to almost all Original Equipment Manufacturers (OEMs) in
            the bicycle industry.
          </li>
          <li>
            <strong className="text-gray-900">Awards & Recognitions:</strong>{" "}
            Numerous awards and recognitions from central and state governments
            for excellence in manufacturing and business practices.
          </li>
        </ul>
      </div>

      {/* Closing Note */}
      <div className="max-sm:px-4">
        <p className="text-gray-700 text-sm leading-relaxed">
          Dass continues to innovate and provide high-quality bicycle parts,
          focusing on durability, performance, and meeting global standards of
          excellence.
        </p>
      </div>
    </div>
  );
}

export default Dass;
